import { Breadcrumb, Button, Modal, Typography } from "antd";
import { useForm } from "antd/es/form/Form";
import { useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { AddEditTagForm } from "../components/AddEditTagForm";
import { TagList } from "../components/TagList";
import { TagFilter } from "../components/TagFilter";
import { useTags } from "../../../../hooks/useTag";

const { Title } = Typography;

export function TagsPage() {
  const [open, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [form] = useForm();
  const [filter, setFilter] = useState({ page: 1, limit: 100 });
  const { data, loading, create, update, remove } = useTags(filter);

  const handleAdd = () => {
    setSelectedItem(null);
    form.resetFields();
    setOpen(true);
  };

  const handleEdit = (item) => {
    setSelectedItem(item);
    form.setFieldsValue(item);
    setOpen(true);
  };

  const handleDelete = async (id) => {
    await remove.mutateAsync(id);
  };

  const handleSubmit = async (values) => {
    if (selectedItem) {
      await update.mutateAsync({ ...values, _id: selectedItem._id });
    } else {
      await create.mutateAsync(values);
    }
    setOpen(false);
    form.resetFields();
  };

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
  };

  return (
    <div style={{ padding: 24 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <Breadcrumb
            items={[{ title: "Bảng điều khiển" }, { title: "Tags" }]}
          />
          <Title level={3} style={{ margin: 0 }}>
            Quản lý tags
          </Title>
        </div>
        <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd}>
          Thêm tag
        </Button>
      </div>

      <div style={{ padding: "24px 0" }}>
        <TagFilter filter={filter} onFilterChange={handleFilterChange} />
      </div>

      <div>
        <TagList
          data={data}
          loading={loading}
          filter={filter}
          onFilterChange={handleFilterChange}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />
      </div>
      <Modal
        title={selectedItem ? "Cập nhật tag" : "Thêm tag"}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
      >
        <AddEditTagForm
          form={form}
          loading={create.isPending || update.isPending}
          onSubmit={handleSubmit}
        />
      </Modal>
    </div>
  );
}
